<div class="header">
  <div class="title">
    <app-pencil-icon
      *ngIf="preFixIcon"
      [name]="preFixIcon"
      [type]="preFixIconType"
    ></app-pencil-icon>
    <span>{{ title }}</span>
  </div>

  <ng-content select="[suffixContent]"></ng-content>
</div>
